"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
var _Text = _interopRequireDefault(require("../components/Text"));
var _theme = require("../theme/");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
// import { hideNotification } from '../actions/notifier';
var Notifier = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Notifier, _Component);
  function Notifier() {
    var _this;
    (0, _classCallCheck2["default"])(this, Notifier);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, Notifier, [].concat(args)), _this.state = {
      hide: false
    }, (0, _assertThisInitialized2["default"])(_this)));
  }
  (0, _createClass2["default"])(Notifier, [{
    key: "render",
    value:
    /*
     * When using the notifier in an app with redux, use the following: 
     * _close = () => {
     *     this.props.dispatch(hideNotification());
     * };
     */

    function render() {
      var _this$props = this.props,
        notifierType = _this$props.notifierType,
        verbiage = _this$props.verbiage,
        showing = _this$props.showing,
        id = _this$props.id,
        testid = _this$props.testid;

      // For storybook
      var close = this.props.close;
      var styles = {
        errorNotifier: {
          backgroundColor: _theme.colors.red
        },
        messageNotifier: {
          backgroundColor: _theme.colors.brandGreen
        },
        notifier: {
          color: _theme.colors.surface,
          height: 'auto',
          left: '0',
          marginLeft: 'auto',
          marginRight: 'auto',
          minHeight: '20px',
          padding: '20px',
          position: 'absolute',
          right: '0',
          top: '2%',
          width: '600px',
          zIndex: '9999',
          maxWidth: '90%'
        },
        closeModalIcon: {
          cursor: 'pointer',
          display: 'inline',
          marginTop: -15,
          marginRight: -15,
          fontSize: 22,
          "float": 'right',
          color: _theme.colors.surface
        }
      };
      if (!showing) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: id || testid,
        style: notifierType === 'error' ? _objectSpread(_objectSpread({}, styles.notifier), styles.errorNotifier) : _objectSpread(_objectSpread({}, styles.notifier), styles.messageNotifier)
      }, /*#__PURE__*/_react["default"].createElement(_Close["default"], {
        style: styles.closeModalIcon
        // onClick={this._close}
        ,
        onClick: close
      }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        align: "center",
        color: _theme.colors.surface,
        medium: true,
        display: "block"
      }, verbiage));
    }
  }]);
  return Notifier;
}(_react.Component);
/**
 *
 * @param {*} theme
 */
Notifier.propTypes = {
  dispatch: _propTypes["default"].func,
  verbiage: _propTypes["default"].string,
  notifierType: _propTypes["default"].string,
  showing: _propTypes["default"].bool
};
var _default = exports["default"] = Notifier;